<template>
  <div>
    <v-container fluid>
      <v-card elevation="0" class="">
        <v-card-title class="secondary--text font-weight-medium py-0">
          <v-row align="center" no-gutters class="">
            <v-col cols="12">
              <h3 class="my-2 primary--text">
                {{ $t("contactRequests.contactRequests") }}
              </h3>
            </v-col>
            <v-col cols="3">
              <v-text-field
                :label="$t('common.search')"
                v-model="nameText"
                :placeholder="$t('landlord.search')"
                class="custom-label-color"
                hide-details="auto"
                outlined
                dense
              >
              </v-text-field>
            </v-col>

            <v-col cols="1" class="ml-2">
              <v-btn color="primary" class="white--text" @click="searchData()">
                Search
              </v-btn>
            </v-col>
          </v-row>
        </v-card-title>
        <v-data-table
          :footer-props="{ 'items-per-page-options': [50, 100, 150, 200, -1] }"
          :headers="headers"
          :items="landlordRequestLists"
          :search="search"
          class="mt-5 datatable mb-9 table-reference-for-scroll"
          :loading="loading"
          mobile-breakpoint="0"
          :options.sync="options"
          disable-sort
          :server-items-length="totalLandlordRequest"
        >
          <!-- :server-items-length="totalLandlordRequest" -->
          <template v-slot:[`item._id`]="{ item }">
            <p class="my-0 py-0">
              {{
                options.page * options.itemsPerPage -
                  options.itemsPerPage +
                  landlordRequestLists
                    .map(function(x) {
                      return x._id;
                    })
                    .indexOf(item._id) +
                  1
              }}
            </p>
          </template>
          <template v-slot:[`item.requestedDate`]="{ item }">
            <p class="my-0 py-0">
              {{
                item.requestedDate
                  ? dateFormat(new Date(parseInt(item.requestedDate)))
                  : "-"
              }}
            </p>
          </template>
          <template v-slot:[`item.isBecomeALandlord`]="{ item }">
            <v-row v-if="item" justify="center">
              {{ item.isBecomeALandlord ? "Yes" : "No" }}
            </v-row>
          </template>
          <template v-slot:[`item.status`]="{ item }">
            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-chip
                  v-if="item.status"
                  class="primary white--text"
                  x-small
                  v-bind="attrs"
                >
                  {{ item.status }}
                  <v-icon v-on="on" x-small class="ml-2" color="white">
                    mdi-arrow-down
                  </v-icon>
                </v-chip>
              </template>
              <v-list>
                <v-list-item
                  v-for="(i, index) in statusOptions(item.status)"
                  :key="index"
                  @click="requestStatusChange(i, item)"
                >
                  <v-list-item-title>{{ i }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </template>
        </v-data-table>
      </v-card>
      <side-drawer v-if="isRequestLandlord">
        <template slot="formDetails">
          <landlord-request-form />
        </template>
      </side-drawer>
    </v-container>
  </div>
</template>

<script>
import { changeLandlordRequestStatus } from "../methods/change_landlord_request_status";
import moment from "moment";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      loading: false,
      search: "",
      nameText: "",
      phoneText: "",
      variables: {
        limit: 50,
        skip: 0
      },
      options: {
        itemsPerPage: 50,
        page: 1
      },
      landlordRequestLists: [],
      totalLandlordRequest: 10
    };
  },
  watch: {
    options: {
      handler() {
        this.variables.limit = this.options.itemsPerPage;
        this.variables.skip =
          this.options.page * this.options.itemsPerPage -
          this.options.itemsPerPage;
        this.landlordLists = [];
        this.$apollo.queries.getContactUs.refetch({
          input: {
            limit:
              this.options.itemsPerPage !== -1
                ? this.options.itemsPerPage
                : 500,
            skip: this.variables.skip
          },
          filter: {
            searchKey: this.nameText
          }
        });
      },
      deep: true
    }
  },
  components: {
    // "add-button": AddButton,
    "side-drawer": () => import("@/core/components/SideDrawer"),
    "landlord-request-form": () =>
      import("./rightSideDrawer/LandlordRequestForm.vue")
  },
  computed: {
    ...mapGetters(["isRequestLandlord"]),
    headers() {
      return [
        {
          text: "#",
          value: "_id"
        },
        {
          text: this.$t("landlord.name"),
          value: "name"
        },
        {
          text: this.$t("landlord.email"),
          value: "email"
        },
        {
          text: this.$t("landlord.phone"),
          value: "phone"
        },
        // {
        //   text: this.$t('landlord.address'),
        //   value: "addressLine1"
        // },
        {
          text: this.$t("landlord.companyName"),
          value: "companyName"
        },
        // {
        //   text: this.$t("landlord.requestedDate"),
        //   value: "requestedDate"
        // },
        {
          text: this.$t("contactRequests.isLandlord"),
          value: "isBecomeALandlord"
        }
      ].map(header => {
        header.align = "center";
        header.width = "2%";
        return header;
      });
    }
  },
  apollo: {
    getContactUs() {
      return {
        query: require("@/landlord/api/queries/get_contact_us.graphql"),
        variables: {
          input: {
            limit: 50,
            skip: 0
          },
          filter: {
            searchKey: this.nameText
          }
        },
        result({ data }) {
          // , loading, networkStatus, refetch
          console.log(data);
          this.landlordRequestLists = this.$format.cloneVariable(
            data.getContactUs.contactUs
          );
          this.totalLandlordRequest = data.getContactUs.contactUs.length;
        }
      };
    }
  },

  methods: {
    searchData() {
      this.$apollo.queries.getContactUs.refetch({
        input: {
          limit:
            this.options.itemsPerPage !== -1
              ? this.options.itemsPerPage
              : this.totalLandlordRequest,
          skip:
            this.options.page * this.options.itemsPerPage -
            this.options.itemsPerPage
        },
        filter: {
          searchKey: this.nameText
        }
      });
    },
    maxLimitPhone() {
      if (this.phoneText.length > 8) {
        this.phoneText = this.phoneText.slice(0, 8);
      }
    },
    editLandlordRequest(item) {
      this.$store.commit("IS_REQUEST_LANDLORD", true);
      this.$store.commit("EDIT_REQUEST_LANDLORD", item);
      this.$store.commit("SHOW_RIGHTSIDE_DRAWER", true);
    },
    statusOptions(staus) {
      if (staus !== "VERIFIED") return ["VERIFIED", "REJECTED", "HOLD"];
      else return ["REJECTED", "HOLD"];
    },
    dateFormat(date) {
      return moment(date, "YYYY-MM-DD").format("DD/MM/YYYY");
    },
    openRightSideDrawer() {
      this.$store.commit("IS_REQUEST_LANDLORD", true);
      this.$store.commit("SHOW_RIGHTSIDE_DRAWER", true);
    },
    requestStatusChange(i, item) {
      const input = { landlordRequestId: item._id, status: i };
      changeLandlordRequestStatus(input).then(async data => {
        if (data.data.changeLandlordRequestStatus)
          this.$root.$emit("snackbar", {
            snackbar: true,
            text: this.$t("landlord.landlordStatus"),
            color: "green"
          });
        if (i === "VERIFIED") await this.createLandlord(item);
        this.$apollo.queries.getContactUs.refetch({
          limit:
            this.options.itemsPerPage !== -1
              ? this.options.itemsPerPage
              : this.totalLandlordRequest,
          skip:
            this.options.page * this.options.itemsPerPage -
            this.options.itemsPerPage
        });
      });
    }
  },
  beforeDestroy() {
    this.$root.$off("refetchLandlordRequest");
  }
};
</script>
<style scoped>
.datatable >>> .v-data-footer__select {
  direction: ltr !important;
}
.datatable >>> .v-data-footer__pagination {
  direction: ltr !important;
}
</style>
